import React from 'react';
import Icon from '../Icon';

const Nav = ({ scrolled, onCTA }) => (
  <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
    <div className="container nav-inner">
      <a href="#top" className="brand">
        <span className="brand-mark"><Icon name="heart" size={15} stroke={2.4} /></span>
        SupportCare
      </a>
      <div className="nav-links">
        <a href="#how">How it works</a>
        <a href="#states">States we cover</a>
        <a href="#proof">Stories</a>
        <a href="#benefits">Benefits</a>
      </div>
      <button className="nav-cta" onClick={onCTA}>
        Check Your Eligibility <Icon name="arrow-right" size={13} stroke={2.5} />
      </button>
    </div>
  </nav>
);

export default Nav;
